import React from 'react';
import ScanPrintContent from './shared/ScanPrintContent';

const CustomerScanPrint = () => {
  return <ScanPrintContent />;
};

export default CustomerScanPrint;
